import Logo from "@/components/layouts/Logo";
import { TEXT } from "@/utils/constants/appConstants/commonConstants";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";


export const ErrorMismatch = () => {
    const navigate = useNavigate()

    return (
        <div className="min-h-screen flex items-center justify-center bg-primary">
            <div className="w-full max-w-md px-6 py-10 bg-white rounded-xl shadow-md">
                <div className="flex justify-center mb-6">
                    <Logo id='email-mismatch-logo' />
                </div>
                <h4 className="text-xl font-semibold text-secondary mb-3" id='email-mismatch-title'>
                    {TEXT.EMAIL_MISMATCH_TITLE}
                </h4>
                <div className="text-sm text-card-foreground space-y-2 mb-6">
                    <p>The email you entered doesn't match your active Microsoft account.</p>
                    <p>For security, please sign out of your current Microsoft account, sign in with the email you're using for GreenSign, and try logging in again.</p>
                    <p>If you need assistance, please contact your administrator.</p>
                </div>
                <Button
                    className="w-full"
                    id='email-mismatch-button'
                    onClick={() => navigate('/')}
                >
                    Back to Login
                </Button>
            </div>
        </div>
    );
}
